import { canUseDom as isBrowser } from "../../can-use-dom";
import { CloudPlatform } from "./enums";
import { getWebpOptions, checkCdnCloudPlatform } from "./options";
var browserGlobalEnv;
function resolveExt(url) {
    return (/\.(\w+)(\?\S*)?$/.exec(url) || [])[1];
}
function getHostname(url) {
    var parts = url.split("/");
    if (parts) {
        return parts[2];
    }
    else {
        return "";
    }
}
/**
 * @name 获取计算后的尺寸
 * @param width
 * @param height
 */
export function getComputedSize(width, height) {
    if (width === void 0) { width = 0; }
    if (height === void 0) { height = 0; }
    var offsetWidth = width, offsetHeight = height;
    if (isBrowser) {
        var rem2px = getWebpOptions().rem2px;
        if (typeof rem2px === "function") {
            offsetWidth = rem2px(width / 100);
            offsetHeight = rem2px(height / 100);
        }
    }
    else {
        // TODO: 服务端图片宽高计算方案待定，暂不处理，默认就会返回未用rem2px转化的尺寸
    }
    return {
        // 真机渲染宽度
        offsetWidth: offsetWidth,
        // 真机渲染高度
        offsetHeight: offsetHeight,
    };
}
/**
 * 根绝网络获取压缩质量和像素比
 * 标准：
 * 网络     | 未知网络/wifi |    4g      | 3g            | 2g
 * 压缩质量  | 90          | 80         | 60            | 60
 * 像素比    | `dpr || 2`  | `dpr || 2` | `min(dpr, 2)` | 1
 * @param {Number} dpr 设备像素比
 */
function getQualityAndDpr(dpr) {
    // 推断网络情况，非所有浏览器支持
    // web端判断不了是否在wifi中，所以当网络是4g时，如果saveData为false，设置网络质量为wifi下的标准质量
    var QUALITY = 80;
    var DPR = dpr || 2;
    // 客户端才能获取网络情况
    if (isBrowser) {
        var navigator_1 = window.navigator;
        var connection = navigator_1.connection || navigator_1.mozConnection || navigator_1.webkitConnection;
        // eslint-disable-next-line no-console
        if (connection && connection.effectiveType) {
            switch (connection.effectiveType) {
                case "4g":
                    // saveData为false，设置网络质量为wifi下的标准质量
                    if (!connection.saveData) {
                        QUALITY = 90;
                    }
                    break;
                case "3g":
                    QUALITY = 60;
                    DPR = Math.min(DPR, 2);
                    break;
                case "2g":
                case "slow-2g":
                    QUALITY = 60;
                    DPR = 1;
                    break;
                default:
                    QUALITY = 90;
                    break;
            }
        }
    }
    return {
        QUALITY: QUALITY,
        DPR: DPR,
    };
}
function resolve(_a) {
    var sourceUrl = _a.source, logicWidth = _a.width, logicHeight = _a.height;
    if (!sourceUrl || !sourceUrl.startsWith("http")) {
        throw new Error("sourceUrl(" + sourceUrl + ") \u9700\u8981\u4E3A\u7F51\u7EDC\u5730\u5740");
    }
    var hostname = getHostname(sourceUrl);
    var _b = getWebpOptions(), isSupportWebp = _b.isSupportWebp, dpr = _b.dpr;
    // 校验是否为合法 cdn 域名
    var cdnCloudPlatform = checkCdnCloudPlatform(hostname);
    if (!cdnCloudPlatform) {
        // 如果是不合法 cdn 域名，暂时无法上报，直接返回false
        return false;
        // throw new Error(`目前仅支持的cdn裁剪的域名有：${CDNHOST.join(",")}，当前域名为：${hostname}`);
    }
    var USER_ENV;
    if (!isBrowser) {
        var _c = getQualityAndDpr(dpr), QUALITY = _c.QUALITY, DPR = _c.DPR;
        USER_ENV = {
            QUALITY: QUALITY,
            DPR: DPR,
            SUPPORTS_WEBP: isSupportWebp,
        };
    }
    else {
        if (!browserGlobalEnv) {
            var _d = getQualityAndDpr(dpr), QUALITY = _d.QUALITY, DPR = _d.DPR;
            browserGlobalEnv = {
                QUALITY: QUALITY,
                DPR: DPR,
                SUPPORTS_WEBP: isSupportWebp,
            };
        }
        USER_ENV = browserGlobalEnv;
    }
    var sourceExt = (resolveExt(sourceUrl) || "").toLowerCase();
    if (!sourceExt) {
        throw new Error("sourceUrl(" + sourceUrl + ") \u4E0D\u5305\u542B\u6709\u6548\u6587\u4EF6\u6269\u5C55\u540D");
    }
    if (sourceExt !== "jpg" && sourceExt !== "jpeg" && sourceExt !== "png") {
        throw new Error("不支持的格式");
    }
    var targetExt = USER_ENV.SUPPORTS_WEBP ? "webp" : sourceExt;
    var targetWidth;
    var targetHeight;
    if (logicWidth || logicHeight) {
        // 计算预期的缩放比例，与 设备、网络、宽度区间取整 有关
        var detectSize = Math.max(logicWidth || 0, logicHeight || 0);
        // offsetWidth:真机渲染宽度  offsetHeight:真机渲染高度
        var _e = getComputedSize(logicWidth, logicHeight), offsetWidth = _e.offsetWidth, offsetHeight = _e.offsetHeight;
        // const realSize = Math.round(
        //   // 浏览器端，利用 REM 关系，得到真实设备上的目标大小
        //   // 服务端与客户端本身环境不一致，无法保证服务端计算的参数，与客户端计算结果一致
        //   (process.server ? detectSize : window.rem2px ? window.rem2px(detectSize / 100) : detectSize ) *
        //     {
        //       FAST: USER_ENV.DPR,
        //       MEDIUM: Math.min(USER_ENV.DPR, 2),
        //       SLOW: 1,
        //     }[USER_ENV.SPEED]
        // );
        var offsetSize = Math.max(offsetWidth || 0, offsetHeight || 0);
        var realSize = Math.round(
        // 浏览器端，利用 REM 关系，得到真实设备上的目标大小
        // 服务端与客户端本身环境不一致，无法保证服务端计算的参数，与客户端计算结果一致
        (!isBrowser ? detectSize : offsetSize) * USER_ENV.DPR);
        var sizeRemainder = realSize % 100;
        var targetSizeRemainder = void 0;
        // 向上取整至 0 26 50 76 100，不支持任意目标尺寸
        if (sizeRemainder === 0) {
            targetSizeRemainder = 0;
        }
        else if (sizeRemainder <= 26) {
            targetSizeRemainder = 26;
        }
        else if (sizeRemainder <= 50) {
            targetSizeRemainder = 50;
        }
        else if (sizeRemainder <= 76) {
            targetSizeRemainder = 76;
        }
        else {
            targetSizeRemainder = 100;
        }
        var targetScale = (Math.floor(realSize / 100) * 100 + targetSizeRemainder) / detectSize;
        // 计算实际请求尺寸
        targetWidth = !logicWidth ? undefined : Math.round(logicWidth * targetScale);
        targetHeight = !logicHeight ? undefined : Math.round(logicHeight * targetScale);
    }
    return {
        ext: targetExt,
        width: targetWidth,
        height: targetHeight,
        quality: USER_ENV.QUALITY,
        cdnCloudPlatform: cdnCloudPlatform,
    };
}
/**
 * 按预设逻辑，计算资源使用 CDN 裁剪转换格式后的 url
 * 成功时返回新资源地址，失败时返回 false
 */
function resolveNewResource(props) {
    if (!props.source || !/^https?:\/\//.test(props.source)) {
        return false;
    }
    // TODO 是否对支持的 CDN 地址做检查，不支持的跳过
    if (!props.width && !props.height) {
        // eslint-disable-next-line no-console
        console.error("Image \u5BBD\u9AD8\u5747\u672A\u6307\u5B9A\uFF0C\u8BF7\u5C3D\u5FEB\u5904\u7406 source: " + props.source);
    }
    try {
        var params = resolve(props);
        if (typeof params === "boolean" && !params) {
            return false;
        }
        var hasQuery = /\?/.test(props.source);
        var joiner = hasQuery ? "&" : "?";
        var extParamStr = void 0;
        if (params.cdnCloudPlatform === CloudPlatform.AlibabaCloud) {
            var queryList = ["x-oss-process=image"];
            if (params.width || params.height)
                queryList.push("/resize");
            if (params.width)
                queryList.push(",w_" + params.width);
            if (params.height)
                queryList.push(",h_" + params.height);
            if ((params.width || params.height) && props.clip)
                queryList.push(props.clip === "center" ? ",m_fill" : "");
            if (params.ext)
                queryList.push("/format," + params.ext);
            queryList.push("/quality,q_" + params.quality);
            extParamStr = queryList.join("");
        }
        else {
            extParamStr = [
                params.width && "w=" + params.width,
                params.height && "h=" + params.height,
                // 注意，CDN 数据可能异常(扩展名与实际格式不一致，如内容为 png 但扩展名为 jpg)
                // 仅 webp 时提供 fmt，其余时候不传（即按原格式转换）
                params.ext === "webp" && "fmt=" + params.ext,
                "q=" + params.quality,
                "fit=" + (props.clip === "center" ? "0" : "1"),
            ]
                .filter(Boolean)
                .join("&");
        }
        return props.source + joiner + extParamStr;
    }
    catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        return false;
    }
}
export function transToWebpUrl(params) {
    return resolveNewResource(params) || params.source;
}
